import api from "../api/index";
import notify from "devextreme/ui/notify";

const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалсоь выполнить запрос"
    }
  ]
});

const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

  // RESOURCE TYPES
  const GET_REFERENCE_TYPES_REQUEST = "GET_REFERENCE_TYPES_REQUEST";
  const GET_REFERENCE_TYPES_COMPLETED = "GET_REFERENCE_TYPES_COMPLETED";
  const GET_REFERENCE_TYPES_ERROR = "GET_REFERENCE_TYPES_ERROR";

// SKILL CATEGORIES
const GET_SKILL_CATEGORIES_REQUEST = "GET_SKILL_CATEGORIES_REQUEST";
const GET_SKILL_CATEGORIES_COMPLETED = "GET_SKILL_CATEGORIES_COMPLETED";
const GET_SKILL_CATEGORIES_ERROR = "GET_SKILL_CATEGORIES_ERROR";

  const GET_DICT_ITEM_REQUEST = "GET_DICT_ITEM_REQUEST";
  const GET_DICT_ITEM_COMPLETED = "GET_DICT_ITEM_COMPLETED";
  const GET_DICT_ITEM_ERROR = "GET_DICT_ITEM_ERROR";

  function requestReferenceTypes() {
    return {
      type: GET_REFERENCE_TYPES_REQUEST,
      isFetchingRefTypes: true
    };
  }

  function requestReferenceTypesCompleted(reftypes) {
    return {
      type: GET_REFERENCE_TYPES_COMPLETED,
      isFetchingRefTypes: false,
      reftypes
    };
  }

  function requestReferenceTypesError(reftypesError) {
    return {
      type: GET_REFERENCE_TYPES_ERROR,
      isFetchingRefTypes: false,
      reftypesError
    };
  }

  function requestDictItem() {
    return {
      type: GET_DICT_ITEM_REQUEST,
      isFetchingDictItem: true
    };
  }

  function requestDictItemCompleted(itemCard) {
    return {
      type: GET_DICT_ITEM_COMPLETED,
      isFetchingDictItem: false,
      itemCard
    };
  }

  function requestDictItemError(itemCardError) {
    return {
      type: GET_DICT_ITEM_ERROR,
      isFetchingDictItem: false,
      itemCardError
    };
  }

  export function getDictItems(dicttype){
    if (dicttype === 1) return getReferenceTypes();
    if (dicttype === 9) return getSkillCategories();
  }

  export function getReferenceTypes() {
    return dispatch => {
      dispatch(requestReferenceTypes());
      return api
        .getReferenceTypesList()
        .then(response => {
          if (response.status === 200) {
            dispatch(requestReferenceTypesCompleted(response.data));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({message}) => message).join(", ");
            }
            logError(message);
            dispatch(requestReferenceTypesError(message));
          } else {
            logError(err);
            dispatch(requestReferenceTypesError(createError("Не удалось загрузить список")));
          }
        });
    };
  }

  export function getDictItem(id, dicttype) {
    return (dispatch) => {
      dispatch(requestDictItem());
      return api.getDictItem(id, dicttype)
        .then(response => {
          if (response.status === 200) {
            let restype = response.data;
            restype = {
              info: restype.info,
              name: (restype.data && restype.data.name) ? restype.data.name : ""
            };
            dispatch(requestDictItemCompleted(restype));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({message}) => message).join(", ");
            }
            logError(message);
            dispatch(requestDictItemError(err.response));
          } else {
            logError(err);
            dispatch(requestDictItemError(createError("Не удалось получить данные")));
          }
        });
    };
  }

function requestSkillCategories() {
  return {
    type: GET_SKILL_CATEGORIES_REQUEST,
    isFetchingSkillCategories: true
  };
}

function requestSkillCategoriesCompleted(skillCategories) {
  return {
    type: GET_SKILL_CATEGORIES_COMPLETED,
    isFetchingSkillCategories: false,
    skillCategories
  };
}

function requestSkillCategoriesError(skillCategoriesError) {
  return {
    type: GET_SKILL_CATEGORIES_ERROR,
    isFetchingSkillCategories: false,
    skillCategoriesError
  };
}

export function getSkillCategories() {
  return dispatch => {
    dispatch(requestSkillCategories());
    return api
      .getSkillCategoriyList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestSkillCategoriesCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestSkillCategoriesError(message));
        } else {
          logError(err);
          dispatch(requestSkillCategoriesError(createError("Не удалось загрузить список")));
        }
      });
  };
}

  export default {
    GET_REFERENCE_TYPES_REQUEST,
    GET_REFERENCE_TYPES_COMPLETED,
    GET_REFERENCE_TYPES_ERROR,

    GET_SKILL_CATEGORIES_REQUEST,
    GET_SKILL_CATEGORIES_COMPLETED,
    GET_SKILL_CATEGORIES_ERROR,

    GET_DICT_ITEM_REQUEST,
    GET_DICT_ITEM_COMPLETED,
    GET_DICT_ITEM_ERROR,

    getReferenceTypes,
    getSkillCategories,
    getDictItem,
    getDictItems
  };
